import React, {Component, FormEvent} from 'react';
import {
  IonButtons,
  IonButton,
  IonContent,
  IonList,
  IonItem,
  IonLabel,
  IonInput,
  IonRow,
  IonCol,
  IonCheckbox,
} from '@ionic/react';
import './Login.css';
import {ApiService} from "../_/ApiService";
import {Static} from "../_/Static";
import _ from '../_';
import ReactHtmlParser from 'react-html-parser';
import {StaticEvent} from "../_/StaticEvent";
import {BaseComponent} from "./_/BaseComponent";

type State = {
  username: string | null,
  password: string | null
}

export default class CheckPassword extends BaseComponent<{}, State> {
  static RoutePathname = /^\/checkpassword/gi;

  constructor(props: {}) {
    super(props);

    this.state = {
      username: '',
      password: '',
    }
  }

  async handleSubmit(e: any) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    // @ts-ignore
    const {password} = this.state;

    // @ts-ignore
    //const {dispatch} = this.props;
    //dispatch(userActions.login(username, password));

    // Get the full query string from the current URL
    const params = new URLSearchParams(window.location.search);

    // Get individual parameters
    const ContextToken = params.get("ContextToken");

    if (ContextToken && password) {
      // WAITING SCREEN
      StaticEvent.LoadingEvent.next(true);

      // POST
      let postData = {
        ContextToken: ContextToken,
        password: password,
      };
      const postUrl = ApiService.urlMapping('~/api/1/_login/checkpassword');
      Static.apiService
        .post(postUrl, postData)
        .subscribe(async (res) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);

            let data = res.data;
            _.debugManager.log(data);

            let error = data.error || null;
            let result = error == null;

            if (result) { // SUCEESS
              let payload = data.payload;

              let processSuccess = async (redirAfterSuccess = true) => {
                let t_customer = payload.userEntity;
                let serverSessionId = payload.SessionID;

                await Static.storageService.setLoggedAsync(serverSessionId, JSON.stringify(t_customer));

                if (redirAfterSuccess) {
                  // @ts-ignore
                  this.props.history.push('/');
                }
              }

              if (payload.SuccessButMayWantToSignupFastLogin) {
                // @ts-ignore
                this.props.history.push('/poppage')
                await processSuccess(false);
              } else {
                await processSuccess();
              }

              //window.location = '/f1';
              //history.pushState({}, 'page 2', '/f1');
              //await _.sharedStateManager.rootNav.setRoot(askMeIndex, {});
              //await this.viewCtrl.dismiss();

            } else {
              alert(error.message);
              // const controller: any = document.querySelector('ion-toast-controller');
              // let msg = await controller.create({
              //   message: error.message,
              //   duration: 2000,
              //   position: 'top'
              // });
              // await msg.present();
            }
          }, async (err) => {
            // CLOSE WAITING SCREEN
            StaticEvent.LoadingEvent.next(false);
            _.debugManager.warn(err);
            alert('網路連線有問題');
          }
        );

    }
  }

  handleInputChange(e) {
    // @ts-ignore
    this.setState({
      [e.target.name]: e.target.value
    });
  }


  updateUserName(e: CustomEvent) {
  }

  logInUser() {
  }

  signUpUser() {
  }

  render() {
    return (
      <>
        {ReactHtmlParser('<ion-toast-controller></ion-toast-controller>')}
        <div className="logo">
          <div className="ilogo"></div>
          <div className="plustitle">懷相工人雲端平台</div>
          <div className="main_logo">
            <div className="bx1"></div>
            <div className="bx2"></div>
            <div className="bx3"></div>
            <div className="bx4"></div>
            <div className="bx5"></div>
            <div className="bx6"></div>
            <div className="bx7"></div>
            <div className="bx8"></div>
            <div className="bx9"></div>
            <div className="bx10"></div>
            <div className="bx11"></div>
            <div className="bx12"></div>
            <div className="bx13"></div>
            <div className="bx14"></div>
            <div className="bx15"></div>
            <div className="bx16"></div>
            <div className="bx17"></div>
            <div className="bx18"></div>
            <div className="bx19"></div>
            <div className="bx20"></div>
            <div className="bx21"></div>
            <div className="bx22"></div>
            <div className="bx23"></div>
            <div className="bx24"></div>
            <div className="bx25"></div>
            <div className="bx26"></div>
            <div className="bx27"></div>
            <div className="bx28"></div>
            <div className="bx29"></div>
            <div className="bx30"></div>
            <div className="bx31"></div>
            <div className="bx32"></div>
            <div className="bx33"></div>
            <div className="bx34"></div>
            <div className="bx35"></div>
            <div className="bx36"></div>
            <div className="bx37"></div>
            <div className="bx38"></div>
            <div className="bx39"></div>
            <div className="bx40"></div>
            <div className="bx41"></div>
            <div className="bx42"></div>
            <div className="bx43"></div>
            <div className="bx44"></div>
            <div className="bx45"></div>
            <div className="bx46"></div>
            <div className="bx47"></div>
            <div className="bx48"></div>
            <div className="bx49"></div>
            <div className="bx50"></div>
            <div className="bx51"></div>
            <div className="bx52"></div>
            <div className="bx53"></div>
            <div className="bx54"></div>
            <div className="bx55"></div>
            <div className="bx56"></div>
            <div className="bx57"></div>
            <div className="bx58"></div>
            <div className="bx59"></div>
            <div className="bx60"></div>
            <div className="bx61"></div>
            <div className="bx62"></div>
            <div className="bx63"></div>
            <div className="bx64"></div>
            <div className="bx65"></div>
            <div className="bx66"></div>
            <div className="bx67"></div>
            <div className="bx68"></div>
            <div className="bx69"></div>
            <div className="bx70"></div>
            <div className="bx71"></div>
            <div className="bx72"></div>
            <div className="bx73"></div>
            <div className="bx74"></div>
            <div className="bx75"></div>
            <div className="bx76"></div>
            <div className="bx77"></div>
            <div className="bx78"></div>
            <div className="bx79"></div>
            <div className="bx80"></div>
            <div className="bx81"></div>
            <div className="bx82"></div>
            <div className="bx83"></div>
            <div className="bx84"></div>
            <div className="bx85"></div>
            <div className="bx86"></div>
            <div className="bx87"></div>
            <div className="bx88"></div>
            <div className="bx89"></div>
            <div className="bx90"></div>
            <div className="bx91"></div>
            <div className="bx92"></div>
            <div className="bx93"></div>
            <div className="bx94"></div>
            <div className="bx95"></div>
            <div className="bx96"></div>
            <div className="bx97"></div>
            <div className="bx98"></div>
            <div className="bx99"></div>
            <div className="bx100"></div>
          </div>
        </div>
        <form noValidate className="loginform" onSubmit={e => this.handleSubmit(e)}>
          <IonList no-lines>
            <IonItem>
              <IonLabel position="floating">密碼</IonLabel>
              <IonInput
                name="password"
                value={this.state.password}
                onInput={(e: any) => this.handleInputChange(e)}

                //onIonChange={this.updateUserName}
                type="password"
                placeholder="輸入密碼"
                autocapitalize="off"
                required></IonInput>
            </IonItem>
          </IonList>

          <IonRow responsive-sm>
            <IonCol>
              <IonButton expand="block" color="primary" type="submit">
                登入
              </IonButton>
            </IonCol>
          </IonRow>
          <IonRow responsive-sm>
            <IonCol size="4" offset="4">
              <IonButton className="linkstyle" fill="clear" size="small" color="dark" onClick={(e) => {
                e.preventDefault();
                e.stopPropagation();

                // @ts-ignore
                this.props.history.push('/ForgotPassword')
              }}>
                忘記密碼？
              </IonButton>
            </IonCol>
          </IonRow>
        </form>
      </>
    );
  }
}
